import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Monitor } from 'lucide-react';
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import { Button } from '@/components/ui/button';

const ScreenSizeWarning = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <Card className="w-full max-w-md text-center">
        <CardHeader className="space-y-4">
          <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-muted">
            <Monitor className="h-7 w-7 text-muted-foreground" />
          </div>
          <CardTitle className="text-2xl">Större skärm krävs</CardTitle>
        </CardHeader>
        <CardContent>
          <CardDescription className="text-base">
            För att få den bästa designupplevelsen rekommenderar vi att du
            använder en dator eller surfplatta med större skärm.
          </CardDescription>
        </CardContent>
        <CardFooter className="flex justify-center pt-2">
          <Button size="lg" onClick={() => navigate('/')}>
            Gå till startsidan
          </Button>
        </CardFooter>
      </Card>
    </div>
  );
};

export default ScreenSizeWarning;
